/** @module Sourcing/DeleteSupplierRequest */
define([
	"dojo/_base/declare",
	"csi/xml",
	"./DeleteSRBase"
], function(declare,xml,DeleteSRBase) {

	return declare(DeleteSRBase, {

		/** 
		 * @override
		 * @property  
		 * to indicate if the action is to delete a Supplier Request 
		 */
		isDeleteSupplierRequest: true,

		/**
		 * Replace "Save" with "Delete" button
		 * @param {View} defView
		 * @param {Action[]} defActions
		 */
		addProxyActions: function(defView, defActions) {
			defActions.addAction(this.getProxyAction("BUTTON_DELETE", true));
			this.inherited(arguments);
		},

		appendSupplierItemQuery: function(q) {
			q.RefAttr(xml.ATTR_PARENT, xml.OP_EQUALS, this.m_urlNode, "Child:QuoteSRLineItem");
		},

		appendSampleQuery: function(q) {
			q.RefAttr(xml.ATTR_PARENT, xml.OP_EQUALS, this.m_urlNode, "Child:SampleSRLineItem");
		}
	});
});
